/* eslint-disable */
// @ts-nocheck
const value: any =
[
    {
        id: 15,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Queensdale',
    },
    {
        id: 17,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Harathi_Hinterlands',
    },
    {
        id: 18,
        expansion: 'base',
        episode: 0,
        type: 'city',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Divinity%27s_Reach',
    },
    {
        id: 19,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Plains_of_Ashford',
    },
    {
        id: 20,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Blazeridge_Steppes',
    },
    {
        id: 21,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Fields_of_Ruin',
    },
    {
        id: 22,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Fireheart_Rise',
    },
    {
        id: 23,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Kessex_Hills',
    },
    {
        id: 24,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Gendarran_Fields',
    },
    {
        id: 25,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Iron_Marches',
    },
    {
        id: 26,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Dredgehaunt_Cliffs',
    },
    {
        id: 27,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Lornar%27s_Pass',
    },
    {
        id: 28,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Wayfarer_Foothills',
    },
    {
        id: 29,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Timberline_Falls',
    },
    {
        id: 30,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Frostgorge_Sound',
    },
    {
        id: 31,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Snowden_Drifts',
    },
    {
        id: 32,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Diessa_Plateau',
    },
    {
        id: 34,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Caledon_Forest',
    },
    {
        id: 35,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Metrica_Province',
    },
    {
        id: 39,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Mount_Maelstrom',
    },
    {
        id: 50,
        expansion: 'base',
        episode: 0,
        type: 'city',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Lion%27s_Arch',
    },
    {
        id: 51,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Straits_of_Devastation',
    },
    {
        id: 53,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Sparkfly_Fen',
    },
    {
        id: 54,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Brisban_Wildlands',
    },
    {
        id: 62,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Cursed_Shore',
    },
    {
        id: 65,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Malchor%27s_Leap',
    },
    {
        id: 73,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Bloodtide_Coast',
    },
    {
        id: 91,
        expansion: 'base',
        episode: 0,
        type: 'city',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/The_Grove',
    },
    {
        id: 139,
        expansion: 'base',
        episode: 0,
        type: 'city',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Rata_Sum',
    },
    {
        id: 218,
        expansion: 'base',
        episode: 0,
        type: 'city',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Black_Citadel',
    },
    {
        id: 326,
        expansion: 'base',
        episode: 0,
        type: 'city',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Hoelbrak',
    },
    {
        id: 335,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Claw_Island',
    },
    {
        id: 873,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Southsun_Cove',
    },
    {
        id: 922,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Labyrinthine_Cliffs',
    },
    {
        id: 988,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Dry_Top',
    },
    {
        id: 1015,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/The_Silverwastes',
    },
    {
        id: 1041,
        expansion: 'hot',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Dragon%27s_Stand',
    },
    {
        id: 1043,
        expansion: 'hot',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Auric_Basin',
    },
    {
        id: 1045,
        expansion: 'hot',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Tangled_Depths',
    },
    {
        id: 1052,
        expansion: 'hot',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Verdant_Brink',
    },
    {
        id: 1062,
        expansion: 'hot',
        episode: 0,
        type: 'raid',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Spirit_Vale',
    },
    {
        id: 1068,
        expansion: 'base',
        episode: 0,
        type: 'guild',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Gilded_Hollow',
    },
    {
        id: 1069,
        expansion: 'hot',
        episode: 0,
        type: 'guild',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Lost_Precipice',
    },
    {
        id: 1149,
        expansion: 'hot',
        episode: 0,
        type: 'raid',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Lost_Precipice',
    },
    {
        id: 1155,
        expansion: 'base',
        episode: 0,
        type: 'city',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Lion%27s_Arch_Aerodrome',
    },
    {
        id: 1156,
        expansion: 'hot',
        episode: 0,
        type: 'raid',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Stronghold_of_the_Faithful',
    },
    {
        id: 1165,
        expansion: 'hot',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Bloodstone_Fen',
    },
    {
        id: 1175,
        expansion: 'lw3',
        episode: 2,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Ember_Bay',
    },
    {
        id: 1178,
        expansion: 'lw3',
        episode: 3,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Bitterfrost_Frontier',
    },
    {
        id: 1185,
        expansion: 'lw3',
        episode: 4,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Lake_Doric',
    },
    {
        id: 1188,
        expansion: 'hot',
        episode: 0,
        type: 'raid',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Bastion_of_the_Penitent',
    },
    {
        id: 1195,
        expansion: 'lw3',
        episode: 5,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Draconis_Mons',
    },
    {
        id: 1203,
        expansion: 'lw3',
        episode: 6,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Siren%27s_Landing',
    },
    {
        id: 1210,
        expansion: 'pof',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Crystal_Oasis',
    },
    {
        id: 1211,
        expansion: 'pof',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Desert_Highlands',
    },
    {
        id: 1214,
        expansion: 'pof',
        episode: 0,
        type: 'guild',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Windswept_Haven',
    },
    {
        id: 1226,
        expansion: 'pof',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/The_Desolation',
    },
    {
        id: 1228,
        expansion: 'pof',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Elon_Riverlands',
    },
    {
        id: 1248,
        expansion: 'pof',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Domain_of_Vabbi',
    },
    {
        id: 1263,
        expansion: 'lw4',
        episode: 1,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Domain_of_Istan',
    },
    {
        id: 1268,
        expansion: 'lw4',
        episode: 1,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Fahranur,_the_First_City',
    },
    {
        id: 1271,
        expansion: 'lw4',
        episode: 2,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Sandswept_Isles',
    },
    {
        id: 1288,
        expansion: 'lw4',
        episode: 3,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Domain_of_Kourna',
    },
    {
        id: 1301,
        expansion: 'lw4',
        episode: 4,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Jahai_Bluffs',
    },
    {
        id: 1310,
        expansion: 'lw4',
        episode: 5,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Thunderhead_Peaks',
    },
    {
        id: 1317,
        expansion: 'lw4',
        episode: 6,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Dragonfall',
    },
    {
        id: 1323,
        expansion: 'pof',
        episode: 0,
        type: 'raid',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/The_Key_of_Ahdashim',
    },
    {
        id: 1330,
        expansion: 'lw5',
        episode: 1,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Grothmar_Valley',
    },
    {
        id: 1343,
        expansion: 'lw5',
        episode: 2,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Bjora_Marches',
    },
    {
        id: 1370,
        expansion: 'base',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Eye_of_the_North',
    },
    {
        id: 1371,
        expansion: 'lw5',
        episode: 3,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Drizzlewood_Coast',
    },
    {
        id: 1419,
        expansion: 'eod',
        episode: 0,
        type: 'guild',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Isle_of_Reflection',
    },
    {
        id: 1422,
        expansion: 'eod',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Dragon%27s_End',
    },
    {
        id: 1428,
        expansion: 'eod',
        episode: 0,
        type: 'city',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Arborstone',
    },
    {
        id: 1438,
        expansion: 'eod',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/New_Kaineng_City',
    },
    {
        id: 1442,
        expansion: 'eod',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Seitung_Province',
    },
    {
        id: 1452,
        expansion: 'eod',
        episode: 0,
        type: 'zone',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/The_Echovald_Wilds',
    },
    {
        id: 1465,
        expansion: 'eod',
        episode: 0,
        type: 'city',
        wikiUrl: 'https://wiki.guildwars2.com/wiki/Thousand_Seas_Pavilion',
    },
]

export default value;
